import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import ScrollToTopButton from "./components/ScrollToTopButton";
import AOS from "aos";
import "aos/dist/aos.css";
import { HashRouter as Router, Routes, Route } from "react-router-dom";

// All pages
import Home from "./components/Home";
// import DemoProduct from './pages/DemoProduct';
import ScrollToTop from "./components/ScrollToTop";
import { useDocTitle } from "./components/CustomHook";

function App() {
  React.useEffect(() => {
    const aos_init = () => {
      AOS.init({
        once: true,
        duration: 1000,
        easing: "ease-out-cubic",
      });
    };

    window.addEventListener("load", () => {
      aos_init();
    });
  }, []);

  useDocTitle("Hilina Mulugeta| Frontend Website Developer");

  return (
    <>
      <Router>
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </ScrollToTop>
        {/* Scroll to Top Button */}
        <ScrollToTopButton />
      </Router>
    </>
  );
}

export default App;
